import uid from "common/utils/uid";
import { DIST_EPSILON } from "geom/core";
import type { DocMigration } from "../docMigration";

const LEGACY_CORNER_BOARD_WIDTH = 4;

const defaultProfileSettings = {
  type: "PROFILE_CATALOG_SETTINGS",
  profileTable: {},
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_136: DocMigration = {
  maxSchemaVersion: "0.0.136",
  description: "Custom profiles for corner boards",
  apply(json: any) {
    const { settings: allSettings } = json;

    // look for custom corner board widths in the exterior trim settings
    const cornerBoardWidthToProfileId: { [key: string]: string } = {};
    const customCornerBoardProfiles: { [key: string]: any } = {};
    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "EXTERIOR_TRIM_SETTINGS") {
        continue;
      }

      const { width } = settings;

      if (width === undefined) {
        continue;
      }

      if (Math.abs(width - LEGACY_CORNER_BOARD_WIDTH) > DIST_EPSILON) {
        let profileId = cornerBoardWidthToProfileId[settings.width];
        if (!profileId) {
          profileId = uid();
          customCornerBoardProfiles[profileId] = {
            name: `Corner Board 1 x ${width}`,
            entityType: "PROFILE_EXTRUSION",
            profileType: "BOARD",
            elevationNoteEnabled: false,
            width: 1,
            height: width,
            nominalWidth: 1,
            nominalHeight: 4,
            elevationNote: `${width}"`,
          };
          cornerBoardWidthToProfileId[width] = profileId;
        }

        settings.outsideCornerBoardProfile = profileId;
        settings.insideCornerBoardProfile = profileId;
      }

      delete settings.width;
    }

    if (Object.keys(customCornerBoardProfiles).length > 0) {
      // create a first settings set if it doesn't exist. Reference first settings set id.
      let firstSettingsSetId: string | undefined = undefined;
      for (const settingsSetId in json.settingsSets) {
        const settingsSet = json.settingsSets[settingsSetId];
        if (settingsSet.sortIndex !== 0) {
          continue;
        }
        firstSettingsSetId = settingsSet.id;
      }

      if (firstSettingsSetId === undefined) {
        const baseSettingsSetId = uid();
        if (!json.settingsSets) {
          (json.settingsSets as any) = {};
        }

        (json.settingsSets[baseSettingsSetId] as any) = {
          entityType: "SETTINGS_SET",
          name: "Base Settings Set",
          id: baseSettingsSetId,
          sortIndex: 0,
        };
        firstSettingsSetId = baseSettingsSetId;
      }

      // add this profiles to an existing profile calatog or create a new one
      let firstSettingsSetProfileSettingsId: string | undefined = undefined;

      for (const settingsId in allSettings) {
        const settings = allSettings[settingsId] as any;
        if ((settings.type as any) === "PROFILE_CATALOG_SETTINGS") {
          if (firstSettingsSetId !== undefined && settings.parentId !== undefined) {
            if (settings.parentId === firstSettingsSetId) {
              firstSettingsSetProfileSettingsId = settingsId;
              (allSettings[settingsId] as any) = {
                ...settings,
                profileTable: { ...settings.profileTable, ...customCornerBoardProfiles },
              };
            }
          }
        }
      }

      if (!firstSettingsSetProfileSettingsId) {
        const newSettingsId = uid();
        (allSettings[newSettingsId] as any) = {
          ...{ ...defaultProfileSettings, profileTable: customCornerBoardProfiles },
          entityType: "SETTINGS",
          id: newSettingsId,
          parentId: firstSettingsSetId,
          sortIndex: 0,
        };
      }
    }

    return json;
  },
};

export default migration_0_0_136;
